<template>
  <div>
    <v-menu v-if="actions.length" top right>
      <v-btn icon slot="activator">
        <v-icon>add</v-icon>
      </v-btn>
      <v-list>
        <v-list-item v-for="action in actions" :key="action.key">
          <v-list-tile @click.native="selectedAction = action">
            <v-list-tile-title>{{ $t(`messenger.menu.actions.${action.key}`) }}</v-list-tile-title>
          </v-list-tile>
        </v-list-item>
      </v-list>
    </v-menu>
    <component
      v-if="selectedAction"
      :is="selectedAction.component"
      :user="user"
      @closeModal="selectedAction = null"
      v-bind="selectedAction.data">
    </component>
  </div>
</template>

<script>
  import chatMessage from '@/mixins/chatMessage'
  import FileUpload from './actions/FileUpload.vue'
  import ShareOffer from './actions/ShareOffer.vue'
  import SharePage from './actions/SharePage.vue'
  import CreateAppointment from './actions/CreateAppointment.vue'
  export default {
    mixins: [chatMessage],
    props: {
      actions: {
        type: Array,
        default: () => [
          { key: 'upload', component: FileUpload },
          { key: 'share', component: ShareOffer },
          { key: 'page', component: SharePage },
          { key: 'appointment', component: CreateAppointment }
        ]
      }
    },
    data () {
      return {
        selectedAction: null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/messenger/Menu.vue